import _union from 'lodash/union';
import { makeStyles } from '@material-ui/core/styles';

export function weightAsLbsAndOunces(weightInOunces) {
  const OUNCES_PER_POUND = 16;
  const lbs = Math.floor(weightInOunces / OUNCES_PER_POUND);
  const ounces = Math.round(((weightInOunces - (lbs * OUNCES_PER_POUND)) * 100)) / 100;
  return [lbs, ounces];
}

export function makeOverridableStyles(baseStyles, styleOverrides, makeStylesParams) {
  return makeStyles( theme => {
    const styles = {};

    const baseStylesObj = (typeof baseStyles === 'function') ? baseStyles(theme) : baseStyles || {};
    const styleOverridesObj = (typeof styleOverrides === 'function') ? styleOverrides(theme) : styleOverrides || {};

    _union( Object.keys(baseStylesObj), Object.keys(styleOverridesObj) ).forEach( key => {
      const baseStyle = baseStylesObj[key] || {};
      const styleOverride = styleOverridesObj[key] || {};

      if( (typeof baseStyle === 'function') || (typeof styleOverride === 'function') ) {
        styles[key] = (params) => ({
          ...( (typeof baseStyle === 'function') ? baseStyle(params) : baseStyle),
          ...( (typeof styleOverride === 'function') ? styleOverride(params) : styleOverride)
        });
      }
      else {
        styles[key] = { ...baseStyle, ...styleOverride };
      }
    });

    return styles;
  }, makeStylesParams );
}
